import { DeskItem } from './DeskItem';
import { PhaserModalConfig } from 'src/games/shared/Modal';
import { PhaserButtonConfig } from 'src/games/shared/Button';
import { Color } from 'src/games/shared/ColorValue';
import { Helpers } from '../../DiagnosisGame/objects/Helpers';
import { GameState } from 'src/games/OrganizeDeskGame/objects/GameState';

export class Utilities {
    /**
    * Returns a random point between minX, minY (inclusive) and maxX, maxY (exclusive)
    */
    public static getRandomPoint(minX, maxX, minY, maxY): Phaser.Geom.Point {
        var x = Math.floor(Math.random() * (maxX - minX) + minX);
        var y = Math.floor(Math.random() * (maxY - minY) + minY);
        return new Phaser.Geom.Point(x, y);
    }

    /**
     * Returns the total number of items in the array (have to count the quantities)
     */
    public static getNumberOfItems(items): number {
        var count = 0;
        items.forEach((item: DeskItem) => {
            count += item.quantity;
        });
        return count;
    }

    /**
     * Initializes an array of desk supplies with random quantities
     */
    public static initializeDeskSupplies(): DeskItem[] {
        var deskSupplies = [];
        var supplies = [...DeskItem.SUPPLIES];
        supplies.forEach((item: DeskItem) => {
            item.quantity = Math.floor(Math.random() * (3 - 0));
            deskSupplies.push(item);
        });
        return deskSupplies;
    }

    /**
     * Initializes an array of desk garbage with random quantities
     */
    public static initializeGarbageItems(): DeskItem[] {
        var deskGarbage = [];
        var garbageItems = [...DeskItem.GARBAGE_ITEMS];
        garbageItems.forEach((item: DeskItem) => {
            item.quantity = Math.floor(Math.random() * (3 - 1) + 1);
            deskGarbage.push(item);
        });
        return deskGarbage;
    }

    /**
     * Checks if the sponge is overlapping with the spill (the player is trying to clean the spill)
     */
    public static isPlayerCleaningSpill(sponge, spill) {
        var spongeBounds = sponge.getBounds();
        var spillBounds = spill.getBounds();
        return Phaser.Geom.Intersects.RectangleToRectangle(spongeBounds, spillBounds);
    }

    /**
     * Returns true only if there are some items on the desk that are not supposed to be there
     */
    public static checkIfExtraItemsOnDesk(deskTop, allDeskItems): boolean {
        var deskTopBounds = deskTop.getBounds();
        var rect = new Phaser.Geom.Rectangle(deskTop.x, deskTop.y, deskTopBounds.width, deskTopBounds.height);
        for (var i of allDeskItems) {
            if (rect.contains(i.x, i.y) && !i.getData('dropped')) {
                return true;
            }
        }
        return false;
    }

    public static getRandomDeskOrder(): number[] {
        var order = [1, 2, 3, 4, 5, 6];
        order = Helpers.scrambleArray(order);
        return order.slice(0, GameState.NUMBER_OF_DESKS);
    }

    /**
    * Shuffle the candidates so they're not in the same order every time
    * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
    */
    public static scrambleArray(array) {
        var j, x, i;
        for (i = array.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = array[i];
            array[i] = array[j];
            array[j] = x;
        }
        return array;
    }

    public static getRandomArrayIndex(arrayLength: number) {
        return Math.floor(Math.random() * arrayLength);
    }

    public static getModalConfig(): PhaserModalConfig {
        var modalConfig = new PhaserModalConfig();
        modalConfig.buttonWidth = 150;
        modalConfig.buttonConfig = new PhaserButtonConfig();
        modalConfig.buttonConfig.smartSize = true;
        modalConfig.buttonConfig.backgroundColor = Color.COLORS.get("light grey");

        return modalConfig;
    }

}



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/objects/Utilities.ts